// Bump with runtime changes: also distinguishes old, still-open browser tabs.
export const RUNTIME_VERSION = 116;
